import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=2f5f3c36&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=ts"
export * from "./newsDetail.vue?vue&type=script&lang=ts"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=2f5f3c36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5f3c36",
  null
  
)

export default component.exports